var _CssBaseline;
import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import CssBaseline from '@mui/material/CssBaseline';
import { getTheme } from '../theme/theme';
import { DefaultAppLayoutProvider } from './VarnishContext';
import { ErrorBoundary } from './ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A top level container for your application that handles errors cleanly,
 * makes the required theme available to child components, and sets up
 * the application layout.
 *
 * If the theme property is provided, it's deeply merged with the default Varnish
 * theme. Which means you can only provide the properties you'd like to override,
 * and those not provided will use the defaults.
 */
export function VarnishApp({
  layout,
  theme,
  children
}) {
  const mergedTheme = getTheme(theme);
  return /*#__PURE__*/_jsx(StyledThemeProvider, {
    theme: mergedTheme,
    children: /*#__PURE__*/_jsxs(ThemeProvider, {
      theme: mergedTheme,
      children: [_CssBaseline || (_CssBaseline = /*#__PURE__*/_jsx(CssBaseline, {})), /*#__PURE__*/_jsx(ErrorBoundary, {
        children: /*#__PURE__*/_jsx(DefaultAppLayoutProvider, {
          layout: layout || 'center-aligned',
          children: children
        })
      })]
    })
  });
}
export default VarnishApp;